import React from "react";

import PhilippinesMap from "views/console/default/components/PhilippinesMap";

const FarmLocationsMap = ({...props}) => {

  return (
    <div className="pt-4 w-full overflow-y-auto">
        
        <PhilippinesMap />

    </div>
  );
};

export default FarmLocationsMap;
